import { ButtonDownEffect, ButtonMode, ButtonStatus, SelectionMode } from "./Const";
import { GLabel } from "./GLabel";
import { Event } from "../events/Event";
import { SoundManager } from "../media/SoundManager";
import { Laya } from "../../Laya";
import { GImage } from "./GImage";
import { Color } from "../maths/Color";
export const ButtonPageAlternatives = {
    [ButtonStatus.Over]: ButtonStatus.Up,
    [ButtonStatus.SelectedOver]: ButtonStatus.Down,
    [ButtonStatus.Disabled]: ButtonStatus.Up,
    [ButtonStatus.SelectedDisabled]: ButtonStatus.Down,
};
const SaveColorSymbol = Symbol();
var tmpColor;
const downEffectValueC = 0.8;
const downEffectValueS = 0.9;
export class GButton extends GLabel {
    constructor() {
        super();
        this._selected = false;
        this._titleStr = "";
        this._iconStr = "";
        this._selectedTitleStr = "";
        this._selectedIconStr = "";
        this._soundVolumeScale = 0;
        this._selectedPage = 0;
        this._downEffect = 0;
        this._scaleEffect = false;
        this._mode = ButtonMode.Common;
        this._soundVolumeScale = 1;
        this._changeStateOnClick = true;
        this.on(Event.ROLL_OVER, this, this._rollover);
        this.on(Event.ROLL_OUT, this, this._rollout);
        this.on(Event.MOUSE_DOWN, this, this._btnTouchBegin);
        this.on(Event.MOUSE_UP, this, this._btnTouchEnd);
        this.on(Event.CLICK, this, this._click);
        this.on(Event.RIGHT_CLICK, this, this._rightClick);
        this.on(Event.UNDISPLAY, this, this._removeFromStage);
    }
    destroy() {
        if (this._selectedController)
            this._selectedController.release();
        super.destroy();
    }
    get title() {
        return this._titleStr;
    }
    set title(value) {
        if (value == null)
            value = "";
        this._titleStr = value;
        super.title = (this._selected && this._selectedTitleStr) ? this._selectedTitleStr : value;
    }
    get selectedTitle() {
        return this._selectedTitleStr;
    }
    set selectedTitle(value) {
        if (value == null)
            value = "";
        this._selectedTitleStr = value;
        super.title = (this._selected && this._selectedTitleStr) ? value : this._titleStr;
    }
    get icon() {
        return this._iconStr;
    }
    set icon(value) {
        if (value == null)
            value = "";
        this._iconStr = value;
        super.icon = (this._selected && this._selectedIconStr) ? this._selectedIconStr : value;
    }
    get selectedIcon() {
        return this._selectedIconStr;
    }
    set selectedIcon(value) {
        if (value == null)
            value = "";
        this._selectedIconStr = value;
        super.icon = (this._selected && this._selectedIconStr) ? value : this._iconStr;
    }
    get downEffect() {
        return this._downEffect;
    }
    set downEffect(value) {
        this._downEffect = value;
    }
    get sound() {
        return this._sound;
    }
    set sound(value) {
        this._sound = value;
    }
    get soundVolumeScale() {
        return this._soundVolumeScale;
    }
    set soundVolumeScale(value) {
        this._soundVolumeScale = value;
    }
    get selected() {
        return this._selected;
    }
    set selected(value) {
        if (this._mode == ButtonMode.Common)
            return;
        if (this._selected != value) {
            this._selected = value;
            this.setCurrentState();
            if (this._selectedTitleStr && this._titleWidget)
                this._titleWidget.p.text = this._selected ? this._selectedTitleStr : this._titleStr;
            if (this._selectedIconStr && this._iconWidget)
                this._iconWidget.p.icon = this._selected ? this._selectedIconStr : this._iconStr;
            if (this._selectedController) {
                if (this._selected) {
                    this._selectedController.selectedIndex = this._selectedPage;
                }
                else if (this._mode == ButtonMode.Check && this._selectedController.selectedIndex == this._selectedPage)
                    this._selectedController.oppositeIndex = this._selectedPage;
            }
        }
    }
    get mode() {
        return this._mode;
    }
    set mode(value) {
        if (this._mode != value) {
            if (value == ButtonMode.Common)
                this.selected = false;
            this._mode = value;
        }
    }
    get selectedController() {
        return this._selectedController;
    }
    set selectedController(value) {
        if (this._selectedController)
            this._selectedController.release();
        this._selectedController = value;
        if (value) {
            value.validate();
            value.onChanged = this.selectChanged.bind(this);
            this.selectChanged();
        }
    }
    get selectedPage() {
        return this._selectedPage;
    }
    set selectedPage(value) {
        this._selectedPage = value;
        if (this._selectedController)
            this.selected = this._selectedPage == this._selectedController.selectedIndex;
    }
    get changeStateOnClick() {
        return this._changeStateOnClick;
    }
    set changeStateOnClick(value) {
        this._changeStateOnClick = value;
    }
    get mouseEnabled() {
        return super.mouseEnabled;
    }
    set mouseEnabled(value) {
        super.mouseEnabled = value;
        if (!this.mouseEnabled) {
            this._over = false;
            this.setCurrentState();
        }
    }
    fireClick(downEffect, clickCall) {
        if (this._mode !== ButtonMode.Common)
            return;
        if (downEffect) {
            this.setState(ButtonStatus.Over);
            Laya.timer.once(100, this, this.setState, [ButtonStatus.Down]);
            Laya.timer.once(200, null, () => {
                this.setState(ButtonStatus.Up);
                if (clickCall == null || clickCall)
                    this.event(Event.CLICK);
            });
        }
        else if (clickCall == null || clickCall)
            this.event(Event.CLICK);
    }
    setState(page) {
        if (this._buttonController) {
            if (page >= this._buttonController.numPages) {
                page = ButtonPageAlternatives[page];
                if (page == null)
                    return;
            }
            this._buttonController.selectedIndex = page;
        }
        if (this._downEffect == ButtonDownEffect.Dark) {
            let isDown = page == ButtonStatus.Down || page == ButtonStatus.SelectedOver || page == ButtonStatus.SelectedDisabled;
            if (!tmpColor)
                tmpColor = new Color();
            for (let child of this.children) {
                if (child instanceof GImage) {
                    if (isDown) {
                        child[SaveColorSymbol] = child.color;
                        tmpColor.parse(child.color);
                        tmpColor.r *= downEffectValueC;
                        tmpColor.g *= downEffectValueC;
                        tmpColor.b *= downEffectValueC;
                        child.color = tmpColor.toString();
                    }
                    else if (child[SaveColorSymbol])
                        child.color = child[SaveColorSymbol];
                }
            }
        }
        else if (this._downEffect == ButtonDownEffect.UpScale || this._downEffect == ButtonDownEffect.DownScale) {
            let rate = this._downEffect == ButtonDownEffect.DownScale ? downEffectValueS : 1 / downEffectValueS;
            if (page == ButtonStatus.Down || page == ButtonStatus.SelectedOver || page == ButtonStatus.SelectedDisabled) {
                if (!this._scaleEffect) {
                    this.scale(this.scaleX * rate, this.scaleY * rate);
                    this._scaleEffect = true;
                }
            }
            else {
                if (this._scaleEffect) {
                    this.scale(this.scaleX / rate, this.scaleY / rate);
                    this._scaleEffect = false;
                }
            }
        }
    }
    setCurrentState() {
        if (this._selected)
            this.setState(this.grayed ? ButtonStatus.SelectedDisabled : (this._over ? ButtonStatus.SelectedOver : ButtonStatus.Down));
        else
            this.setState(this.grayed ? ButtonStatus.Disabled : (this._over ? ButtonStatus.Over : ButtonStatus.Up));
    }
    _controllersChanged() {
        super._controllersChanged();
        let c = this.getController("button");
        if (this._buttonController != c) {
            this._buttonController = c;
            this.setCurrentState();
        }
    }
    _onPartChanged(which) {
        if (which == "title") {
            if (this._titleStr)
                this.title = this._titleStr;
        }
        else if (which == "icon") {
            if (this._iconStr)
                this.icon = this._iconStr;
        }
    }
    selectChanged() {
        this.selected = this._selectedPage == this._selectedController.selectedIndex;
    }
    _rollover() {
        this._over = true;
        if (this._down)
            return;
        if (this.grayed)
            return;
        this.setState(this._selected ? ButtonStatus.SelectedOver : ButtonStatus.Over);
    }
    _rollout() {
        this._over = false;
        if (this._down)
            return;
        if (this.grayed)
            return;
        this.setState(this._selected ? ButtonStatus.Down : ButtonStatus.Up);
    }
    _btnTouchBegin(evt) {
        if (evt.button != 0)
            return;
        this._down = true;
        if (this._mode == ButtonMode.Common) {
            this.setState(this.grayed ? ButtonStatus.SelectedDisabled : ButtonStatus.Down);
        }
    }
    _btnTouchEnd() {
        if (this._down) {
            this._down = false;
            if (this._mode == ButtonMode.Common) {
                this.setState(this.grayed ? ButtonStatus.Disabled : (this._over ? ButtonStatus.Over : ButtonStatus.Up));
            }
            else {
                if (!this._over
                    && this._buttonController
                    && (this._buttonController.selectedIndex == ButtonStatus.Over || this._buttonController.selectedIndex == ButtonStatus.SelectedOver)) {
                    this.setCurrentState();
                }
            }
        }
    }
    _removeFromStage() {
        if (this._over)
            this._rollout();
    }
    _click(evt) {
        var _a;
        if (this._sound)
            SoundManager.playSound(this._sound).volume = this._soundVolumeScale;
        let ss = (_a = this.parent) === null || _a === void 0 ? void 0 : _a.selection;
        if (ss && ss.mode != SelectionMode.None) {
            ss.handleClick(this, evt);
            if (this._mode != ButtonMode.Common)
                return;
        }
        if (this._mode == ButtonMode.Check) {
            if (this._changeStateOnClick) {
                this.selected = !this._selected;
                this.event(Event.CHANGED);
            }
        }
        else if (this._mode == ButtonMode.Radio) {
            if (this._changeStateOnClick && !this._selected) {
                this.selected = true;
                this.event(Event.CHANGED);
            }
        }
        else {
            if (this._selectedController)
                this._selectedController.selectedIndex = this._selectedPage;
        }
    }
    _rightClick(evt) {
        let ss = this.parent.selection;
        if (ss && ss.mode != SelectionMode.None) {
            ss.handleClick(this, evt);
        }
    }
}
